import axios from "axios";
import queryString from "query-string";
import URLHelper from "../helpers/URLHelper";

const SelfMeasureServices = {
  getControlHistory: async (from, to, type, patient, pagination) => {
    // type: diabetes | hypertension | weight
    const params = `?from=${from}&to=${to}&type=${type}&patient=${URLHelper.encodeQueryParamValue(patient)}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/rpm/control/history/${params}&${queryString.stringify(pagination)}`
    );
    return response;
  },
  getStepsHistory: async (from, to, type, patient, pagination) => {
    const params = `?from=${from}&to=${to}&type=${type}&patient=${URLHelper.encodeQueryParamValue(patient)}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/training/steps/steps-history${params}&${queryString.stringify(
          pagination
        )}`
    );
    return response;
  },
};

export default SelfMeasureServices;
